import { type DesignElementBase } from "..";
import { createIcon } from "../design-element-utils";

const designElement: DesignElementBase = {
  tags: ["google-domains", "Google Domains"],
  iconColor: "#71D5D5", // pluto
  getIcon(options) {
    return createIcon(
      `
      <svg width="19" height="20" viewBox="-7 -2 26 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_2671_17382)">
          <path
            d="M18.0881 1.60059C18.5397 1.60059 18.8444 2.04859 18.666 2.45125L12.3015 17.2419C12.0599 17.7833 11.5095 18.1339 10.9015 18.1339H6.55187C6.1003 18.1339 5.78461 17.7006 5.96441 17.2979L6.46265 16.1366L7.54971 9.96992L10.7079 6.24059L12.3166 2.49259C12.5568 1.95125 13.007 1.60059 13.615 1.60059H18.0881Z"
            fill="#4285F4"
          />
          <path
            d="M10.7299 6.1884C9.6236 5.1444 8.10831 4.5084 6.44203 4.52574C3.10399 4.56174 0.426151 7.2124 0.46321 10.4457C0.498896 13.6284 3.15203 16.1884 6.42007 16.2337C6.43517 16.1937 9.3436 11.7591 9.3436 11.7591C9.3436 11.7591 10.7299 6.19107 10.7299 6.1884Z"
            fill="#FBBC04"
          />
          <path
            d="M10.7299 6.18848C10.7299 6.18848 6.41599 16.2351 6.42011 16.2351C6.47226 16.2365 6.52442 16.2365 6.57658 16.2351C9.91599 16.1991 12.5925 13.5498 12.5554 10.3151C12.5376 8.69648 11.8403 7.23781 10.7299 6.18848Z"
            fill="#EA4335"
          />
        </g>
        <defs>
          <clipPath id="clip0_2671_17382">
            <rect
              width="18.6667"
              height="18.6667"
              fill="white"
              transform="translate(0.0514526 0.666992)"
            />
          </clipPath>
        </defs>
      </svg>
      `,
      "#F1FBFB", // pluto-2
      options?.borderColor || "#E0E2E6",
      options?.size || "24",
    );
  },
};

export default designElement;
